// mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));


export default function OfferPass() {

  return (
    <RootStyles>
      <Typography variant="body2">
        다른 제안을 원한다고 응답 하셨습니다<br />
        새로 매칭되는 회사가 있으면 다시 연락드릴게요!
      </Typography>
    </RootStyles>
  )
}
